import React from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Polish (18-B2 batch): 404 with "did you mean". Recognises the common wrong
 * shapes for our real routes and suggests the fixed link. Legacy /badges,
 * /awards and /leaderboard already redirect in App.js — this catches the rest.
 */
const RESHAPES = [
  { re: /^\/orgs?\/([^/]+)\/?$/i, to: (m) => `/o/${m[1]}` },
  { re: /^\/opportunity\/([^/]+)\/?$/i, to: (m) => `/opportunities/${m[1]}` },
  { re: /^\/users?\/([^/]+)\/?$/i, to: (m) => `/u/${m[1]}` },
  { re: /^\/collective\/([^/]+)\/?$/i, to: (m) => `/collectives/${m[1]}` },
  { re: /^\/campaign\/([^/]+)\/?$/i, to: (m) => `/campaigns/${m[1]}` },
];

export default function NotFound() {
  const { pathname } = useLocation();
  let suggestion = null;
  for (const { re, to } of RESHAPES) {
    const m = pathname.match(re);
    if (m) { suggestion = to(m); break; }
  }
  return (
    <div data-testid="route-not-found" className="max-w-3xl mx-auto px-6 py-24 text-center">
      <div className="font-display text-4xl text-forest">Page not found</div>
      <p className="text-neutral-600 mt-3">That link doesn't go anywhere — it may have moved or never existed.</p>
      {suggestion && (
        <p className="mt-5 text-neutral-700" data-testid="route-did-you-mean">
          Did you mean{" "}
          <Link to={suggestion} data-testid="route-did-you-mean-link" className="text-forest font-medium underline underline-offset-4">
            {suggestion}
          </Link>
          ?
        </p>
      )}
      <Link to="/" data-testid="route-not-found-home" className="inline-block mt-6 text-forest font-medium underline underline-offset-4">Back to the homepage</Link>
    </div>
  );
}
